module.exports = __webpack_public_path__ + "static/media/header.51e996e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Mentors/img/header.jpg
// module id = 274
// module chunks = 0